import React, { createContext, useContext, useState, useEffect } from 'react';
import isUndefined from 'lodash/isUndefined';

export const AuthServiceContext = createContext({
  service: null,
  loggedIn: null,
});

export const AuthServiceProvider = ({ authService: service, ...rest }) => {
  const [loggedIn, setLoggedIn] = useState(service?.loggedIn?.());
  useEffect(() => {
    if (!service?.addLoginHandler) return;
    const handler = setLoggedIn;
    service.addLoginHandler(handler);

    return () => {
      service.removeLoginHandler(handler);
    };
  }, [service]);

  const value = { service, loggedIn };

  return <AuthServiceContext.Provider value={value} {...rest} />;
};

export const useAuthService = () => {
  const authService = useContext(AuthServiceContext);

  if (isUndefined(authService?.service)) {
    throw new Error(
      'useAuthService must be used within a AuthServiceProvider provided with the authService',
    );
  }

  return authService?.service;
};
